import { Fragment, useState } from 'react'

import { Visibility } from 'globalTypes'

import { Dialog, Transition } from '@headlessui/react'
import Button from 'Root/App/Button'
import ItemVisibilityForCollection from 'Root/App/Item/ItemVisibilityForCollection'

import VisibilityOptions from './VisibilityOptions'
import styles from './index.module.css'

interface ChangeVisibilityProps {
  id: string
  collectionId: string
  visibility: Visibility
  onUpdateVisibility: (visibility: Visibility) => void
}

const ChangeVisibility = ({
  id,
  collectionId,
  visibility,
  onUpdateVisibility,
}: ChangeVisibilityProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div>
      <Button
        subType="circle"
        className="rounded-full flex w-8 h-8 justify-center items-center bg-gray-200 text-sm"
        onClick={() => setIsOpen((isOpen) => !isOpen)}
      >
        <ItemVisibilityForCollection
          id={id}
          collectionId={collectionId}
          visibility={visibility}
        />
      </Button>

      <Transition
        as={Dialog}
        show={isOpen}
        onClose={() => setIsOpen((isOpen) => !isOpen)}
        className={styles.dialogWrapper}
        style={{ zIndex: 99999 }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.dialogFrame} />
        </Transition.Child>

        <div className={styles.visibilityTransitionWrapper}>
          <div className={styles.visibilityChildContainer}>
            <Transition.Child
              as={VisibilityOptions}
              enter={styles.enter}
              enterFrom={styles.enterFrom}
              enterTo={styles.enterTo}
              leave={styles.leave}
              leaveFrom={styles.leaveFrom}
              leaveTo={styles.leaveTo}
              visibility={visibility}
              onClose={() => setIsOpen((isOpen) => !isOpen)}
              onSave={onUpdateVisibility}
            />
          </div>
        </div>
      </Transition>
    </div>
  )
}

export default ChangeVisibility
